// @ts-check
import React from "react"
import { isTaskReportItem } from "../../../utils/report.utils"

/**
 * @param {import("./ModuleCell.molecule").ModuleCellProps<import("../../../services/reports.service.types").AnyTaskReportItem>} props
 * @returns {JSX.Element | null}
 */
export function ModuleCell(props) {
  const { ctx, isHoldingModifierDown, onLeftClickModuleName } = props
  const { row, table, getValue } = ctx
  const module = getValue()
  const rowData = row.original
  const isTask = isTaskReportItem(rowData)

  if (row.getIsGrouped() || !isTask) {
    return null
  }

  return (
    <>
      <div
        className={`overflow-hidden white-space-nowrap text-overflow-ellipsis ${isHoldingModifierDown ? "ctrl-selectable" : ""}`}
        onClick={() => {
          if (isHoldingModifierDown && rowData.moduleId) {
            onLeftClickModuleName?.(table, rowData.moduleId)
          }
        }}
        title={module || ""}
      >
        {module}
      </div>
    </>
  )
}
